import styled from 'styled-components';

export const RangeSliderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 20%;
  position: relative;
  bottom: 10px;
  gap: 4px;

  .range-slider {
      width: 100%;
      .range-slider__range {
        background: ${({ theme }) => theme.colors.primary.main};
      }
      .range-slider__thumb {
        background: ${({ theme }) => theme.colors.primary.main};
      }
      .single-thumb {
        width: 0;
      }
      .range-slider__thumb[data-lower] {
        width: 0;
      }
      .range-slider__range {
        border-radius: 6px;
      }
    }

  @media(max-width: 500px) {
      width: 50%;
      margin-top: 8px;
    }
  header {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 700;
  }
`;

export const ConditionalInputGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 16px;
  width: 100%;
`;
